module.exports = __webpack_public_path__ + "img/fourth.66534000.png";